import getChanges from "./getChanges";

const refreshIfChanged = (prevProps, currentProps, adId) => {
  const { targetingHasChanged, needsRefresh } = getChanges(
    prevProps,
    currentProps
  );

  if (needsRefresh) {
    const getSlot = () =>
      window.googletag
        .pubads()
        .getSlots()
        .find(slot => slot.getSlotElementId() === adId);

    if (targetingHasChanged) {
      window.googletag.cmd.push(() => {
        const slot = getSlot();
        slot.updateTargetingFromMap(currentProps.targeting);
      });
    }

    window.googletag.cmd.push(() => {
      const slot = getSlot();
      window.googletag.pubads().refresh([slot]);
    });
  }
};

const refreshIfNecessary = (prevProps, currentProps, adId) => {
  if (window.googletag && currentProps.isDisplayed) {
    refreshIfChanged(prevProps, currentProps, adId);
  }
};

export default refreshIfNecessary;
